import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0512',
    ecrans: ['00-2']
});
